import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { getCurrentUrl } from '../data/common';
import { mediaData } from '../data/mediaData';
import ShareComponentWrapper from './ShareComponentWrapper';

const ShareIconWrapper = forwardRef(({ callGaHandler, pauseSlideOnTap, storyHeadText }, ref) => {
    const [showShareComponent, setShowShareComponent] = useState(false);
    const [isDisplayShare, setIsDisplayShare] = useState(false);

    const closeShareOption = () => {
        setShowShareComponent(() => false);
        setIsDisplayShare(() => false);
    }

    const showShareComponentHandler = (isDisplay = false) => {
        pauseSlideOnTap(false, 'pause');
        if (showShareComponent || isDisplayShare) {
            // callGaHandler("Share", "Share_close");
            closeShareOption();
        } else {
            callGaHandler("Share", "Share_open");
            isDisplay ? setIsDisplayShare(() => true) : setShowShareComponent(() => true);
        }
    };

    // create share data object
    const shareData = {
        title: 'Curvv.ev: Shaped for You',
        text: "Check out Curvv.ev's sleek new look!",
        url: getCurrentUrl(),
    };

    const onShareClick = async () => {
        try {
            if (navigator.canShare) {
                await navigator.share(shareData)
                    .then(() => showShareComponentHandler())
                    .catch((error) => {
                        console.log("Sharing failed", error);
                        // showShareComponentHandler(true);
                    });
            } else {
                console.log(`Your system doesn't support sharing files.`);
                // showShareComponentHandler(true);
            }
        } catch (err) {
            // showShareComponentHandler(true);
            console.error("Share failed:", err.message);
        }
    }

    useImperativeHandle(ref, () => {
        return {
            closeShareOption,
        }
    });

    return (
        <>
            <div className="share-slide-icon" onClick={onShareClick}>
                <img src={`${mediaData["shareIconWhite"]}`} alt="share" className="share-icon-img" />
            </div>

            {isDisplayShare ? <ShareComponentWrapper callGaHandler={callGaHandler} storyHeadText={storyHeadText} showShareComponentHandler={showShareComponentHandler} /> : null}
        </>
    )
});

export default ShareIconWrapper